export const GENERIC_LOCKED_RESOURCE_MESSAGE =
  "The resource is locked! Contact support for more details";

export type StudentLimitError = {
  status?: false;
  message?: string;
  error_code?: number;
  student_limit?: number;
  active_student_count?: number;
};

export const isStudentLimitError = (payload: unknown): payload is StudentLimitError => {
  return (
    typeof payload === "object" &&
    payload !== null &&
    (payload as StudentLimitError).error_code === 423
  );
};

export const formatStudentLimitMessage = (payload: unknown): string => {
  const error =
    typeof payload === "object" && payload !== null ? (payload as StudentLimitError) : {};
  const message =
    typeof error.message === "string" && error.message.trim()
      ? error.message.trim()
      : GENERIC_LOCKED_RESOURCE_MESSAGE;

  if (typeof error.student_limit === "number" && typeof error.active_student_count === "number") {
    return `${message} Limit: ${error.student_limit}, Active students: ${error.active_student_count}`;
  }

  return message;
};
